<template>
  <model-table
    :collection="kitchenDisplayTypes"
    :orderable="true"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      {
        name: 'deliveryStages',
        field: 'deliveryStagesChips',
        component: 'chips',
        limitValues: 4
      },
      {
        name: 'deliveryOperations',
        field: 'deliveryOperationsChips',
        component: 'chips',
        limitValues: 8
      },
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary, align: 'right' },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
    :has-library="!currentCircuit.isLibrary"
    :library-collection="kitchenDisplayTypeLibrary"
    :library-columns="[
      { field: 'name' },
      {
        name: 'deliveryStages',
        field: 'deliveryStagesChips',
        component: 'chips',
        limitValues: 4
      },
      {
        name: 'deliveryOperations',
        field: 'deliveryOperationsChips',
        component: 'chips',
        limitValues: 8
      },
    ]"
    :link-to-library-collection="kitchenDisplayTypesToLinkOrPromote"
    :link-options="kitchenDisplayTypeLibrary.data"
    :link-filter="libraryFilterFunction"
    :show-link="true"
  >
    <kitchen-display-type-form />
  </model-table>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import KitchenDisplayTypeForm from 'src/modules/admin/kitchen-display/KitchenDisplayTypeForm'

export default {
  name: 'KitchenDisplayTypeTable',
  components: {
    ModelTable,
    KitchenDisplayTypeForm
  },
  configuration: ['currentCircuit'],
  models: {
    kitchenDisplayTypes: {
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    kitchenDisplayTypesToLinkOrPromote: {
      immediate: true
    },
    kitchenDisplayTypeLibrary: {
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (val, update) {
      update(() => {
        this.libraryFilterString = val.length ? val.trim() : null
      })
    }
  }
}
</script>
